<script lang="ts">

</script>

<section class="main-intro"></section>

<style>
    .main-intro {
        position: relative;
        margin-top: 110px;
    }

    @media(max-width: 767px) {
        .main-intro {
            margin-top: 62px;
        }
    }
</style>
